<template>
    <div>
        <nav-bar-main></nav-bar-main> 

        <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro/>
        </b-alert>

        <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro-expired/>
        </b-alert>


        <div v-if="error != null" class="alert alert-danger" role="alert">
            {{$t(error)}}
        </div>

        <Loader />
        <div v-if="plantDetails != null && unitsDetails != null" class="animated fadeIn container-fluid">
            
            <b-row class="mt-4">
                <b-col v-for="(ambiente,index) in ambienti" :key="'amb-'+index"  xl="4" lg="6" md="12" sm="12">
                    <b-card border-variant="primary" body-class="nopad">

                        <div slot="header">
                            {{ambiente.name}}
                            <div class="card-header-actions">
                                <b-link href="#" class="card-header-action btn-close" @click="eliminaAmbiente(ambiente,index)" >
                                    <i class="fa fa-trash"></i>
                                </b-link>
                            </div>
                        </div>

                        <div class="imgDiv" :id="'imgDiv'+index">
                            <img v-for="(lampInfo) in ambiente.lamps" :id="'ambdot-'+ambiente.id+'-'+lampInfo.id+picLoaded['pic'+ambiente.id]" :key="'linfo-'+ambiente.id+'-'+lampInfo.id+'-'+picLoaded['pic'+ambiente.id]" :src="'/img/dot_' + lampInfo.status+'.png'" :class="{'dotImg':true, 'dotImgHighlight': lampInfo.id == highlightedLamp.toUpperCase()}"   v-bind:style="{marginLeft: pos(index,lampInfo,ambiente.id).x, marginTop:pos(index,lampInfo,ambiente.id).y}"  />
                            <b-img :src="imageUrl(ambiente.id)" fluid @click="apriModal(index)" @load="picReady(ambiente.id)" />
                            <div v-if="$store.getters.isProExpired" style="background-color: rgba(0,0,0,0.8); position:absolute; top: 0px; left:0px; right:0px; bottom: 0px" ></div>
                        </div>
                    </b-card>
                </b-col>
                <b-col>
                    <b-button v-if="$store.getters.userRole =='installer' || $store.getters.userRole =='collab'" @click="showModalDisclaimer()" ><span style="font-size:40px; font-weight: bold">+</span><br/>{{this.$t("zone.add_zone")}}</b-button>
                </b-col>
            </b-row>
            <div style="height: 80px">&nbsp</div>
        </div>

            <b-modal v-if="currentAmbiente != null && currentAmbiente.name != null" id="modal-ambiente" :title="'Dettaglio ' + currentAmbiente.name" modal-class="modal-fullscreen" :hide-footer="true" @show="apertoDettaglioMappa">
            
            <template v-slot:modal-header="{ close }">
                <b-row class="ModalPlanimetrieHeader">
                    <b-col cols="auto"><h5 >Dettaglio</h5></b-col>
                    <b-col cols="7">
                        <span v-if="updatingName">{{currentAmbiente.name}}</span>
                        <b-form-input v-if="!updatingName" v-model="currentAmbiente.name" placeholder="Specificare un nome"></b-form-input>
                    </b-col>
                    <b-col cols="4">
                        <b-button @click="chiudiDettaglioMappa($event)" variant="light" class="mr-1"><span class="typo-label" :content="$t('planimetry.save')" v-tippy="{ placement : 'bottom',  arrow: true}"><i class="fa fa-save" style="color:#0090CD"></i></span></b-button>                    </b-col>
                    <b-col cols="1" class="float-right">
                        <button class="close close-x" @click="chiudiDettaglioMappa($event)">x</button>
                    </b-col>
                </b-row>
            </template>

            <b-container fluid>
                <b-row>
                    <b-col sm="6" md="7" lg="8">
                        <div class="imgDiv" :id="'imgDivBig'" style="border:2px solid black; overflow: hidden;"   v-on:mousemove="mmove($event)" v-on:mouseup="mup($event)" >
                            <!--<drag-it-dude v-for="(lampInfo,index) in currentAmbiente.lamps" :id="'dit'+index"
                                    :key="'linfo2Big-'+currentAmbiente.id+'-'+lampInfo.id" v-bind:style="{left: pos(-1,lampInfo).x, top:pos(-1,lampInfo).y}"
                                    @activated="startLampDrag(lampInfo,index)"
                                    @dropped="endLampDrag(lampInfo,index)">
                                <img :id="'dot'+index" :src="'/img/dot_' + lampInfo.status+'.png'" :class="[{dotSel: lampInfo.selected},'dotImgBig']" />    -->
                              <!--  <b-popover :target="'dot'+index"
                                    placement="top"
                                    :title="'Lampada ' + lampInfo.id"
                                    triggers="hover focus"
                                    :content="'ID: ' + lampInfo.id" /> -->
                            <!--</drag-it-dude> -->
                            
                           
                               <img v-for="(lampInfo,index) in currentAmbiente.lamps" :key="'linfo2Big-'+currentAmbiente.id+'-'+lampInfo.id + imgLoaded"
                                ondragstart="return false"
                                :id="'dot'+lampInfo.id" :ref="'dot'+lampInfo.id" :src="'/img/dot_' + lampInfo.status+'.png'"  :class="[{dotSel: lampInfo.selected},'dotImgBig']"
                                v-bind:style="{left: pos(-1,lampInfo).x, top:pos(-1,lampInfo).y}" v-on:mousedown="mdown(lampInfo, index ,$event)"  />

                                <img id="dragged" src="/img/dot_blu.png" class="dotImgBig dotSel" style="visibility: hidden" />
                           

                            <panZoom id="zoomContainer" ref="zoomContainer" @transform="zooming"  :options="{minZoom: 1.0, maxZoom: 5, bounds: true, boundsPadding: 1}" style="overflow: hidden">
                            <b-img id="imgBig" ref="imgBig" :src="imageUrl(currentAmbiente.id)" fluid ondragstart="return false" @load="bigImgLoaded" @drop="dropLamp(null,-1,$event)" @dragover.prevent />
                            </panZoom>
                            <b-button variant="warning" class="uploadButton"><i class="cui-cloud-upload icons" @click="uploadImg"></i></b-button>
                            <span class="infoTip" :content="$t('planimetry.info')" v-tippy="{ placement : 'top',  arrow: true}"> <i class="fa fa-2x fa-info-circle ml-3 mt-2" style="color:gold" ></i></span>
                            <div id="dropzoneContainer" v-if="showDropZone">
                                <b-button variant="danger" class="closeButton"><i class="fa fa-window-close" @click="closeDropZone"></i></b-button>
                                <vue-dropzone v-if="showDropZone"  ref="myVueDropzone" id="dropzone" :options="dropZoneOptions" v-on:vdropzone-file-added="fileAdded" v-on:vdropzone-sending="sendingImage" ></vue-dropzone>
                            </div>
                        </div>
                        
                    </b-col>
                    <b-col sm="6" md="5" lg="4" class="lampList">
                        <b-tabs v-model="tabIndex" class="PlanimetrieTabs">

                            <!-- elenco scenari -->
                            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
                            <b-tab v-if="this.ruoloUtente(this.$store.getters.userId)=='installer' || this.ruoloUtente(this.$store.getters.userId)=='collab' ||  this.$store.state.user.usertype=='admin'" :title="$t('scene.scene_list')" lazy>
                                <p>{{$t('scene.scene_search')}}</p>
                                
                                <b-row style="display: flex; align-items: center">
                                    <b-col cols="6">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="filtro"></b-form-input>
                                            <!-- Attach Right button -->
                                            <b-input-group-append>
                                                <b-button variant="primary" @click="filtro = ''"><i class="fa fa-eraser"></i></b-button></i></b-button>
                                            </b-input-group-append>       
                                        </b-input-group>
                                    </b-col>    
                                    <b-col cols="6">
                                        <!-- aggiungi scena -->
                                        <add-scene :ambientId="this.currentAmbiente.id"></add-scene>

                                    </b-col>
                                </b-row>
                            
                                <!--<b-container fluid>-->
                                <table class="table tabLampadeDragDrop" >
                                    <thead>
                                        <tr>
                                            <th>Num.</th>
                                            <th>Desc.</th>
                                            <th>Zone</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(scene,index) in this.$store.state.plantScenes" :key="'row-'+index" :id="'lamprow-'+lamp.id" :draggable="!lamp.alreadyAdded && imgLoaded" :class="{draggableRow: true,lampUsed:(getMappeLamp(lamp) != ''), highlightedAdded:(selectedLamp != null && selectedLamp.id != lamp.id && lamp.alreadyAdded) ,highlightedRow: (selectedLamp != null && selectedLamp.id == lamp.id)}" @click="highlightLamp(lamp,index,$event)" @dragstart="dragLamp(lamp,index,$event)">
                                            <td><strong>{{scene.id}}</strong></td>
                                            <td>{{lamp.desc}}</td>
                                            <td>{{lamp.cu_type}}</td>
                                            <td>{{lamp.cu_id}}</td>
                                            <td>{{getMappeLamp(lamp)}}</td>
                                            <td><span class="float-right"><b-button v-if="getMappeLamp(lamp).includes(currentAmbiente.name)" variant="white" class="p-0 m-0"><i class="fa fa-trash" style="color:black" @click="showModalRimuoviLampada(lamp)"></i></b-button></span></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!--</b-container>-->
                            </b-tab>
                            </show-at>
                        </b-tabs>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>

        <!-- Modal Rimuovi lampada da mappa-->
        <b-modal 
            id="modal-remove-lamp" 
            ref="modalRemoveLamp"
            centered 
            hide-header
            @ok="rimuoviLampada(lampToRemove)"
            >
            <h5 v-if="this.lampToRemove!=null">{{$t('planimetry.remove_lamp',{lamp: this.lampToRemove.id})}}</h5>
        </b-modal>

        <!-- Modal Disclaimer su upload photo-->
        <b-modal
            ref="modalDisclaimerPhoto"
            id="modal-disclaimer-photo"
            :title="$t('settings.normaTitle')"
            :ok-title="$t('settings.normaAccept')"
            @ok="accettazioneDisclaimerPhoto"
        >
            <label for="typo-label">
            <disclaimer-photo-ITA v-if="$t('language')=='IT'"></disclaimer-photo-ITA>
            <disclaimer-photo-GER v-if="$t('language')=='DE'"></disclaimer-photo-GER>
            <disclaimer-photo-ENG v-else></disclaimer-photo-ENG>
            </label>
        </b-modal>

    </div>
</template>

<script>

import Vue from 'vue'

import NavBarMain from '@/components/NavBarMain'
import NavBarDispositivi from '@/components/NavBarDispositivi'
import DisclaimerPhotoITA from '@/locales/DisclaimerPhotoITA';
import DisclaimerPhotoENG from '@/locales/DisclaimerPhotoENG';
import DisclaimerPhotoGER from '@/locales/DisclaimerPhotoGER';
import BannerProExpired from '@/components/BannerProExpired';
import AddScene from '@/components/AddScene';
import BannerPro from '@/components/BannerPro';
import {showAt, hideAt} from 'vue-breakpoints';
//import DragItDude from 'vue-drag-it-dude';

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import panZoom from 'vue-panzoom'
Vue.use(panZoom);

import jsPDF from 'jspdf';
import JsPDFAutotable from 'jspdf-autotable' ;

import { mapState } from 'vuex';
import CreateSceneDialog from './CreateSceneDialog.vue';


export default {
    name: 'AmbientiPlanimetrie',
    components: {
        NavBarMain,
        NavBarDispositivi,
        Event,
        BannerPro,
        BannerProExpired,
        DisclaimerPhotoITA,
        DisclaimerPhotoENG,
        DisclaimerPhotoGER,
        vueDropzone: vue2Dropzone,
        jsPDF,
        JsPDFAutotable,
        hideAt, 
        showAt,
        AddScene,
        CreateSceneDialog
    },
    props: ['plantId'],
    data() {
        return {
            section: "ambienti",
            highlightedLamp: "",
            filtro: "",
            tabIndex: 0,
            lampToRemove:null,
            draggedLamp: null,
            showDropZone: false,
            imgLoaded: false,
            imgUploaded: false,
            pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,  
            picLoaded: {},
            updatingName: false,
            dropZoneOptions: {
                url: process.env.VUE_APP_API_REST_URL,
                maxFilesize: 1.5,
                acceptFiles: "image/*",
                autoProcessQueue: false,
                autoQueue: false,
                maxFiles: 1
            },
            dragging: false,
            drgX: '0px',
            drgY: '0px',
            dragStartEv: null,
            lampListFields: [
                {key: 'id', label: 'ID' },
                {key: 'status', label: 'Stato'}
            ],
            allLampsFields: [
                {key: 'id', label: 'ID' },
                {key: 'cu_id', label: 'Centrale'},
                {key: 'desc', label: 'Nome'}
            ],
            currentAmbiente: {},
            selectedLamp: null,
            
            theme: 'bootstrap4',
            template: 'default',  
            filtroLampadeLibere: false
        }     
    
    },
    filters: {
        
        tipoCentrale: function(value) {
            if (value == 'cablecom') return "Centrale CableCom"
            return "Centrale " + value
        },
        
    },
    computed: {
        ...mapState(['loading','error','commandsPending','commandResponse']),
        
        rndId() {
            return Math.random();
        },
        /*tabIndex() {
            if (this.currentAmbiente != null && this.currentAmbiente.isNew) return 1;
            return 0;
        },*/
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null) return null;
            if (plant.id != this.plantId) return null;
            return plant;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        lampListItems() {
            if (this.currentAmbiente == null || this.currentAmbiente.lamps == null) return [];
            return this.currentAmbiente.lamps;
        },
        selectedLampDetails() {
            if (this.selectedLamp == null) return null;
            const selLamp = this.selectedLamp;
            const lampDet = this.allLamps.filter(function(l){
                return l.id == selLamp.id;
            });
            console.log("selected lamp details:", lampDet);
            if (lampDet != null && lampDet.length > 0) return lampDet[0];
            return null;
        },
        allLamps() {
            var lamps = [];
            
            var self = this;
            var flt = this.filtro;
            var flt2 = this.filtroLampadeLibere;
            //console.log("ricomputo allLamps, flt2=" + flt2);
            
            if (this.unitsDetails != null && this.currentAmbiente != null) {
                const llitems = this.lampListItems;
                
                this.unitsDetails.forEach(function(u) {
                    lamps = lamps.concat(
                        u.lamps.reduce(
                            function(filtered, l) {
                                if (flt != null && flt != "") {
                                   if (l.id.indexOf(flt.toUpperCase()) >= 0 || self.getMappeLamp(l).toLowerCase().indexOf(flt.toLowerCase()) >=0 || u.cu_id.indexOf(flt) >= 0 || u.cu_type.toLowerCase().indexOf(flt.toLowerCase()) >= 0 || l.desc.toLowerCase().indexOf(flt.toLowerCase()) >= 0) {
                                    } else {
                                        return filtered;
                                    }
                                }
                                //console.log("mappe lamp " + l.id + " " + (flt2 == true) + " ->" + self.getMappeLamp(l));
                                if (flt2 == 'true' && self.getMappeLamp(l) != '') return filtered;

                                l["cu_id"] = u.cu_id; 
                                var alreadyAdded = false;
                                const alamp = llitems.filter(function(al) {
                                    return (al.id == l.id);
                                })
                                if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                l["alreadyAdded"] = alreadyAdded;
                                filtered.push(l);
                                return filtered;
                            }, []
                        )
                    );

                });
            }
            console.log("all lamps:",lamps);
            return lamps;
        },
        lampsOnMaps(){
            var lamps_on_maps=[];
            lamps_on_maps= this.allLamps.filter (function(lamp) 
            {
                return (lamp.alreadyAdded == true);
            });
            console.log("lamps on maps",lamps_on_maps);
            return lamps_on_maps
        },
        ambienti() {
            console.log("Sezione: ",this.section);
            if (this.plantDetails == null || this.plantDetails[this.section] == null) return [];
            let self = this;
            
            return this.plantDetails[this.section].map(function(a){
                console.log("mappo " + self.section, a);
                let lamps1 = a.lamps.filter(function(l) {
                    return self.findLamp(l.id) != null;
                });

                let lamps = lamps1.map(function(l){
                    //trovo la lampada
                    var status = "ok";
                    let lampInfo = self.findLamp(l.id);
                    if (lampInfo != null) {
                        if (self.hasError(lampInfo)) status = 'err';
                    }

                    return {id: l.id, status: status, px: l.px, py: l.py, selected: false}
                })
                a.lamps = lamps;
                return a;
            });
        }
        
    },
    mounted() {
        console.log("scenari mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails + ", scene:" + this.$store.state.plantScenes)
        if (this.plantDetails != null || (this.$store.state.plantScenes==null)) {
            var dataReady = this.loadData();
        }
        else
        {
            console.log("scenari mounted ",this.$store.state.plantScenes);
        }

    },
    updated() {
        console.log("dispositiviImpianto updated, idImpianto=" + this.plantId+", plantDetails=", this.plantDetails+ ", error:" + this.error)
        if (this.plantDetails == null && this.error == null && this.$store.state.user != null) {
            this.$store.dispatch('loadPlantDetails', this.plantId)
        } 
    },
    
    watch: {
        loading(val,oldval) {
            console.log("loading changed:" + val+", error=" + this.error)
            if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            } else if (val == false && this.$store.state.commandResponse.pending == false && this.$store.state.commandResponse.command != null) {
                console.log("devo elaborare risposta comando ", this.$store.state.commandResponse);
                /*var alert = {
                    timeLeft: 5,
                    msg: "Eseguito comando " + this.$store.state.commandResponse.command + " su centrale " + this.$store.state.commandResponse.cu,
                    countDownChanged: function(cd) {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.alerts.push(alert);*/
            } else if (val == false && this.plantDetails != null && this.unitsDetails != null) {
                console.log("dati pronti");
               /* this.$refs.imgBig.ondragstart=function(){
                    return false;
                }*/
            }
            this.$forceUpdate();
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
        },
        commandsPending(val,oldval) {
            console.log("commandsPending " + val, "configInProgress =" + this.configInProgress);
            
        },
        commandResponse(val,oldval) {
            console.log("updated commandResponse:",val);
            if (val.command == 'disclaimerPhotoAccepted'&& val.pending == false) {
                this.aggiungiPianta();       
            } 
        }
    },
    methods: {

          loadData() {
            if (this.plantDetails == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
                return false;
            } else if (this.$store.state.plantCollections==null) {
                console.log("scenari, ricarico plantCollections")
                this.$store.dispatch('loadPlantCollections', this.plantId);
                return false;
            } else if (this.sceneDetails == null) {
                console.log("scenari mounted ricarico plant scenes");
                this.$store.dispatch('loadPlantScenes', this.plantId)
                return false;
            } else {
                console.log("scenari dati pronti")
                this.$forceUpdate();
            }
            return true;
        },
               ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) 
            {
               return user[0].role;
            }
            return "?";
        },
        getMappeLamp(lamp) {
            if (this.ambienti == null || this.ambienti.length == 0) return "";
            var mappe = "";
            for (var a = 0; a < this.ambienti.length; a++) {
                var amb = this.ambienti[a];
                if (amb.lamps != null && amb.lamps.length > 0){
                    for (var l=0; l<amb.lamps.length; l++) {
                        var ll = amb.lamps[l];
                        if (ll.id == lamp.id) {
                            mappe += ", " + amb.name
                        }
                    }
                }
            }
            if (mappe.length > 2) return mappe.substr(2);
            return mappe;
        },
        filtraLampadeLibere(value) {
            console.log("filtro lampade libere:" + value);
        },
        evidenzia() {
            
            if (this.highlightedLamp != "" && this.highlightedLamp.length == 4) {
                console.log("evidenzio " + this.highlightedLamp);
            }
        },
        zooming(srcObj) {
            var lamps = this.currentAmbiente.lamps;
            let tr = srcObj.getTransform();
            //console.log("zooming=" + tr.scale, tr);
            if (lamps != null && lamps.length > 0) {
                for (var l=0; l<lamps.length; l++) {
                    var lamp = lamps[l];
                    //console.log("lampInfo:",lamp);
                    var lampDiv = document.getElementById("dot"+lamp.id);
                    //console.log("lampDiv=",lampDiv, lampDiv.getBoundingClientRect());
                    let bgElem = document.getElementById("imgBig");
                    //console.log("bgImg = " + bgElem.clientWidth + "x" + bgElem.clientHeight);

                    var newX = lamp.px * bgElem.clientWidth * tr.scale / 100.0 - 32 + tr.x;
                    var newY = lamp.py * bgElem.clientHeight * tr.scale / 100.0 - 32 + tr.y;
                    //console.log("newx="+newX+",newY="+newY);
                    lampDiv.style.left = newX+"px";
                    lampDiv.style.top = newY+"px";
                }
            }
        },
        findLamp(id) {
            var lamp = null;
            if (this.unitsDetails == null) return null;
            this.unitsDetails.forEach(function(u){
                u.lamps.forEach(function(l){
                    if (l.id == id) lamp = l;
                })
            })
            
            return lamp;
        },
        mostraPaginaCentrali() {
            this.$router.push({name: 'Centrali', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaTuttiDispositivi() {
            this.$router.push({name: 'TuttiDispositivi', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaPlanimetrie() {
            this.$router.push({name: 'Planimetrie', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaAmbienti() {
            this.$router.push({name: 'Ambienti', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaZone() {
            this.$router.push({name: 'Zone', params: {pid: this.$store.state.currentPlant.id}})
        },
        apertoDettaglioMappa() {
            console.log("Aperto dettaglio " + this.currentAmbiente.isNew);
            this.tabIndex = 0;
            if (this.currentAmbiente.isNew) {
                this.showDropZone = true;

            }
        },
        showModalDisclaimer()
        {
            var acceptedDate= new Date(this.$store.state.user.disclaimerPhotoAccepted);
            if (acceptedDate.getFullYear()>2019 && acceptedDate.getFullYear()<2200)
            {
                console.log("DisclaimerPhoto già accettata in data",acceptedDate);
                this.aggiungiPianta();
            }
            else
            {
                this.$refs['modalDisclaimerPhoto'].show();
            }    
        },
        accettazioneDisclaimerPhoto()
        {
           var actualDate=new Date();
           console.log("Dispatch accettazione disclaimer",actualDate);
           this.$store.dispatch('dbSaveDisclaimerPhoto',{acceptedDate: actualDate});
        },
        aggiungiPianta() {

            const plant = this.$store.state.currentPlant;
            var mappe = plant[this.section];
            let numMappe = (mappe == null) ? 0 : mappe.length;
            if (this.$store.getters.isProExpired) {

                if (numMappe >= this.$store.state.appConfig.maxPlants) {
                    this.$bvModal.msgBoxConfirm("Funzionalità PRO Scadute. Per ripristinare le funzionalità rinnova il servizio PRO.", {
                        title: 'Limite ' + this.section + ' raggiunto',
                        okVariant: 'success',
                        okTitle: 'Rinnova PRO',
                        cancelTitle: 'CHIUDI',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                        //this.$root.$emit('openSettingsEvent');
                        this.$router.push({
                            name: "GeneraliImpianto",
                            params: { plantId: this.$store.state.currentPlant.id }
                        });
                        }
                    });
                    return;
                }


            }


            if (plant.plant_type == 'basic') {
                if (numMappe >= this.$store.state.appConfig.maxPlants) {
                    var msg = (this.$store.state.appConfig.maxPlants > 0) ? "Su impianti Basic è possibile configurare un massimo di " + this.$store.state.appConfig.maxPlants + " " + this.section : "Funzionalità disponibile solo su impianti PRO";

                    this.$bvModal.msgBoxConfirm(msg, {
                        title: 'Limite ' + this.section + ' raggiunto',
                        okVariant: 'success',
                        okTitle: 'Passa a PRO',
                        cancelTitle: 'CHIUDI',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                        //this.$root.$emit('openSettingsEvent');
                        this.$router.push({
                            name: "GeneraliImpianto",
                            params: { plantId: this.$store.state.currentPlant.id }
                        });
                        }
                    });
                    return;
                }
            }

            const pianta = {
                id: parseInt(Math.random() * 10000),
                name: "",
                lamps: [],
                isNew: true 
            };
            
            if (mappe == null)  {
                Vue.set(this.$store.state.currentPlant,this.section,[]);
                mappe = this.$store.state.currentPlant[this.section];
            }
            mappe.push(pianta);
            this.imgUploaded = false;
            this.apriModal(mappe.length-1);

        },
        picReady(id) {
            console.log("picReady " + id, this.picLoaded);
            Vue.set(this.picLoaded,'pic'+id,id);
            //this.$forceUpdate();
        },
        eliminaAmbiente(ambiente,index) {
            const self = this;
            this.$bvModal.msgBoxConfirm('Sicuro di vole eliminare questa pianta?', {
                    title: 'Attenzione!',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'ELIMINA',
                    cancelTitle: 'ANNULLA',
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(value => {
                    console.log("risposto con:" + value);
                    if (value) {
                        self.$store.state.currentPlant[self.section].splice(index,1);
                        self.$store.dispatch("aggiornaMappe",{plantId: self.plantDetails.id, mapType: self.section, maps: self.$store.state.currentPlant[self.section]});
                    }
                });
        },
        chiudiDettaglioMappa(ev) {
            console.log("chiuso dettaglio mappa", ev);
            const self = this;
            if (this.currentAmbiente == null) return;
            if (this.currentAmbiente.name.trim() == '') {
                ev.preventDefault();
                this.$bvModal.msgBoxConfirm('Occorre specificare un nome per l\'ambiente', {
                    title: 'Attenzione!',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'OK',
                    cancelTitle: 'ABBANDONA',
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(value => {
                    console.log("risposto con:" + value);
                    if (! value) {
                        //chiudo la modale ed elimino l'ambiente aggiunto
                        self.$store.state.currentPlant[self.section].pop();
                        self.currentAmbiente = null;
                        self.$bvModal.hide('modal-ambiente');
                        self.$forceUpdate();
                    }
                })
                return;
            }

            var mappe = this.plantDetails[this.section];
            //console.log("mappe:", mappe);
            /*mappe.forEach(function(m) {
                if (m.lamps != null && m.lamps.length > 0) {
                    m.lamps.forEach(function(l){
                        delete l["status"];
                        delete l["selected"];
                    });
                }
            });*/
            //console.log("mappe=",mappe);
            mappe.forEach(function(m) {
                m.isNew = false;
            });

            this.currentAmbiente.isNew = false;

            this.$store.dispatch("aggiornaMappe",{plantId: this.plantDetails.id, mapType: this.section, maps: mappe});
            self.$bvModal.hide('modal-ambiente');
            
        },
        stateDesc: function(value) {
            if (this.hasError(value)) 
                return this.$t('planimetry.lamp_error');
            return this.$t('planimetry.lamp_ok');
        },
        hasError: function(lampDet) {
            return lampDet.error_bat_short == 'ON' || lampDet.error_hardware == 'ON' || lampDet.error_batt_test == 'ON' || lampDet.error_com == 'ON' || lampDet.error_led == 'ON';
        },
        showModalRimuoviLampada(lamp) {
            this.lampToRemove=lamp;
            this.$refs['modalRemoveLamp'].show();
        },
        rimuoviLampada(lamp) {
            this.selectedLamp=null;
            for (var i=0; i< this.currentAmbiente.lamps.length; i++) {
                if (this.currentAmbiente.lamps[i].id == lamp.id) {
                    this.currentAmbiente.lamps.splice(i,1);
                    break;
                }
            }
        },
        dragLamp(lamp,index,ev) {
            console.log("dragStart",lamp,index,ev)
            this.draggedLamp = lamp;
            var img = document.createElement("img");
            img.src = '/img/dot_drag.png';
             //" class="dotImgBig dotSel" style="visibility: hidden" />
            img.style.width = "32px";
            img.style.height = "32px";
            ev.dataTransfer.setDragImage(img,16,16);
        },
        highlightLamp(lamp,index,ev) {
            let self = this;
            console.log("highlight",lamp,index,this.currentAmbiente.lamps)
            if (lamp.alreadyAdded) {
                var selLamp = this.currentAmbiente.lamps.filter(function(l) {
                    return l.id == lamp.id;
                })
                if (selLamp != null) {
                    this.selLampDot(selLamp[0],-1);
                }
            }
        },
        dropLamp(lamp,index,ev) {
            ev.preventDefault();
            console.log("drop!",ev);
            if (this.draggedLamp != null) {
                
                const w = ev.target.offsetWidth;
                const h = ev.target.offsetHeight;
                const px = ev.offsetX * 100 / w;
                const py = ev.offsetY * 100 / h;

                var status_dragged="";
                if(this.draggedLamp.error_batt_short=="OFF" && this.draggedLamp.error_batt_test=="OFF" 
                    && this.draggedLamp.error_com=="OFF" && this.draggedLamp.error_hardware=="OFF" && this.draggedLamp.error_led=="OFF")
                    status_dragged="ok";
                else
                    status_dragged="err";

                this.currentAmbiente.lamps.push(
                    {
                        id: this.draggedLamp.id,
                        status: status_dragged,
                        px: px,
                        py: py,
                        selected: false
                    }
                )

                this.draggedLamp = null;
            }
        },
        bigImgLoaded() {
            const elem = document.getElementById("imgBig");
            if (elem == null) return;
            console.log("image loaded " + elem.src);

            //rimuovi filtri lampade non assegnate nei tab 0 e 1 (da usare solo nel tab 2)
            console.log("tabIndex",this.tabIndex);
            if(this.tabIndex!=2) 
            {
                this.filtroLampadeLibere=false;
                this.filtro="";
            }

            if (elem.src.indexOf('empty_map') > 0) return;
            this.imgLoaded = true;
        },
        closeDropZone() {
            this.showDropZone = false;
            this.$refs.myVueDropzone.removeAllFiles();
        },
        uploadImg() {
            console.log("upload img")
            this.showDropZone = true
        },
        imageUrl(ambid) {
            if (this.currentAmbiente != null && this.currentAmbiente.id == ambid) {
                console.log("imageUrl, isNew=" + this.currentAmbiente.isNew + "," + this.imgUploaded + ", lambdaUrl=" + process.env.VUE_APP_API_REST_URL);
                if (this.currentAmbiente.isNew && !this.imgUploaded) {
                    return "/img/empty_map.jpg";
                }
            } else {
                console.log("lamda_url:" + process.env.VUE_APP_API_REST_URL);
                return process.env.VUE_APP_API_REST_URL + "?action=getResource&type="+this.section+"&id="+this.plantId+"-"+ambid+"&rnd=" + Math.random();
            }
            return process.env.VUE_APP_API_REST_URL + "?action=getResource&type="+this.section+"&id="+this.plantId+"-"+ambid+"&rnd=" + Math.random();
            //return process.env.VUE_APP_ROOT_URL + "/img/" + this.section +"/" + this.plantId + '-' + ambid + '.jpg?rnd=' + Math.random();
        },
        sendingImage(file,xhr,formData) {
            console.log("sendingImage",file,xhr,formData);
            console.log(file.type, file.dataURL);
            const buf = Buffer.from(file);
            console.log(buf.toString('base64'));
            //xhr.setRequestHeader("Content-Type","application/json")
        },
        fileAdded(file,dataUrl) {
            console.log("file added",file);
            const self = this;
            const reader = new FileReader();
            reader.onloadend = function(result) {
                console.log("result:",result);
                self.axios.post('', {
                    action: 'uploadImage',
                    plantId: self.plantDetails.id,
                    type: self.section,
                    resId: self.currentAmbiente.id,
                    data: result.target.result
                })
                    .then(function (response) {
                        console.log("post eseguita",response);
                        self.$nextTick(() => {
                            self.showDropZone = false;
                            self.$refs.myVueDropzone.removeAllFiles();
                            self.imgUploaded = true;
                            self.$forceUpdate();
                        });
                    })
                    .catch(function (error) {
                        console.log("errore post",error);
                    });


            }
            reader.readAsDataURL(file);

        },
        mdown(obj,index, ev) {
            //console.log("mdown",obj, ev)
            if (obj != null) {
                this.selLampDot(obj,-1);
                if (this.tabIndex != 2) return;
                this.dragging = true;
                this.dragStartEv = ev
                this.drgX = 0 + ev.srcElement.offsetLeft
                this.drgY = 0 + ev.srcElement.offsetTop
                console.log("startX=" + this.drgX+", startY=" + this.drgY)
            } 
            //this.dragging = true;
            //this.dragStartEv = ev
            //this.selLampDot(obj,-1);
        },
        mmove(ev) {
            
            if (!this.dragging) return
            //console.log("move " + this.dragging,ev)
            //console.log("move",ev)
            ev.preventDefault();
            let draggedEl = document.getElementById("dragged")
            if (draggedEl != null) {
                draggedEl.style.visibility = 'visible'
                draggedEl.style.left = (ev.clientX - this.dragStartEv.clientX + this.drgX)+'px'
                draggedEl.style.top = (ev.clientY-this.dragStartEv.clientY + this.drgY)+'px'
            }
        },
        mup(ev) {
            //console.log("mup",ev)
            if (this.dragging && this.dragStartEv != null) {
                let elem = document.getElementById("imgBig");
                let w = elem.clientWidth;
                let h = elem.clientHeight;

                var trX = 0.0;
                var trY = 0.0;
                var scale = 1.0

                var zoomC = this.$refs.zoomContainer;
                //console.log("zoomC",zoomC);
                if (zoomC != null) {
                    var panZoomObj = zoomC.$panZoomInstance;
                    //console.log("panZoomInstance",panZoomObj);
                    var tr = panZoomObj.getTransform();
                    trX = tr.x;
                    trY = tr.y;
                    scale = tr.scale;
                }

                let draggedEl = document.getElementById("dragged")
                draggedEl.style.visibility = "hidden"
                
                let dx = (ev.clientX - this.dragStartEv.clientX) * 100 / w /scale
                let dy = (ev.clientY - this.dragStartEv.clientY) * 100 / h /scale
                console.log("dx=" + dx + ", dy=" + dy)
                let obj = this.selectedLamp
                var newX = Math.min(100,Math.max(0,obj.px + dx));
                var newY = Math.min(100,Math.max(0,obj.py + dy));
                obj.px = newX;
                obj.py = newY;
            }
            this.dragging = false
            this.dragStartEv = null;
        },
        dragX(ev) {
            //console.log("drag!",ev);
            let dx = ev.screenX - this.dragStartEv.screenX
            let dy = ev.screenY - this.dragStartEv.screenY
            console.log("dx=" + dx + ", dy=" + dy);
        },
        dragstartX(obj, ev) {
            console.log("drag start! " + obj.id, ev)
            this.dragging = true;
            this.dragStartEv = ev;
            return true;
        },
        dragendX(obj,ev) {
            console.log("drag end! " + obj.id, ev)
            this.dragging = false;
            let elem = document.getElementById("imgBig");
            let w = elem.clientWidth;
            let h = elem.clientHeight;
            
            let dx = ev.offsetX * 100.0 / w;
            let dy = ev.offsetY * 100.0 / h;
            var newX = Math.min(100,Math.max(0,obj.px + dx));
            var newY = Math.min(100,Math.max(0,obj.py + dy));
            console.log("px=" + obj.px + ", py=" + obj.py + ", dx=" + dx + ", dy=" + dy+", newx=" + newX+", newY=" + newY);
            
            obj.px = newX;
            obj.py = newY;

            /*this.dragging = false;
            if (dragElem != null) {
                //console.log("pos:",dragElem.offsetLeft, dragElem.offsetWidth)
                let px = Math.min((dragElem.offsetLeft + 32) * 100.0 / w, 100); 
                let py = Math.min((dragElem.offsetTop + 32) * 100.0 / h, 100);
                //console.log("percentuale " + obj.id+" - " + dragElem.offsetLeft+" => px=" + px + ", " + dragElem.offsetTop + " => py=" + py)
                obj.px = px;
                obj.py = py;
            }*/

            return true;
        },
        startLampDragX(obj,ev) {
            console.log("startLampDrag",obj,ev)
            this.selLampDot(obj,-1);
            this.dragging = true;
        },
        endLampDragX(obj,index) {
            if (!this.dragging) return;
            console.log("endLampDrag",obj,index);
            let dragElem = document.getElementById("dit"+index);
            //console.log("element:",dragElem);
            let elem = document.getElementById("imgBig");
            let w = elem.clientWidth;
            let h = elem.clientHeight;
            this.dragging = false;
            if (dragElem != null) {
                //console.log("pos:",dragElem.offsetLeft, dragElem.offsetWidth)
                let px = Math.min((dragElem.offsetLeft + 32) * 100.0 / w, 100); 
                let py = Math.min((dragElem.offsetTop + 32) * 100.0 / h, 100);
                //console.log("percentuale " + obj.id+" - " + dragElem.offsetLeft+" => px=" + px + ", " + dragElem.offsetTop + " => py=" + py)
                obj.px = px;
                obj.py = py;
            }
        },
        selLampDot(obj, index) {
            console.log("sel lamp dot:" + index, obj);
            if (this.selectedLamp != null) {
                this.selectedLamp.selected = false;
            }
            obj.selected = true;
            this.selectedLamp = obj

            if (this.tabIndex == 2) {
                var elem = document.getElementById('lamprow-'+obj.id);
                if(elem !=null)
                {
                 elem.scrollIntoView();
                }
            } else if (this.tabIndex == 1) {
                var elem = document.getElementById('lrow-'+obj.id);
                elem.scrollIntoView();
            }

        },
        lampInfo(ambientIndex,lampIndex) {
            let lampInfo = ambienti[ambientIndex].lamps[lampIndex];
            return lampInfo;
        },
        pos(index,lampInfo, ambid) {
            //console.log("calcolo pos per " + lampInfo.id +", index " + index+", ambid="+ambid+", piloaded:" + this.picLoaded['pic'+ambid]);
            
            var trX = 0.0;
            var trY = 0.0;
            var scale = 1.0

            var zoomC = this.$refs.zoomContainer;
            //console.log("zoomC",zoomC);
            if (zoomC != null) {
                var panZoomObj = zoomC.$panZoomInstance;
                //console.log("panZoomInstance",panZoomObj);
                var tr = panZoomObj.getTransform();
                trX = tr.x;
                trY = tr.y;
                scale = tr.scale;
            }

            
            var elem = null;
            var delta = 8;
            var dotSize = 16;
            if (index <0) {
                elem = document.getElementById("imgBig");
                delta = 32;
                dotSize = 64;
            } else {
                elem = document.getElementById("imgDiv"+index);
            }

            if (lampInfo.id == this.highlightedLamp.toUpperCase()) {
                delta = 32;
            }

            if (elem == null) return {x: '0px', y:'0px'};
            let w = elem.clientWidth;
            let h = elem.clientHeight;
            //console.log("lamp.px=" + lampInfo.px+", lamp.py=" + lampInfo.py+" img=" + w + "x" + h);
            let px = lampInfo.px * w * scale / 100 - delta + trX;
            let py = lampInfo.py * h * scale / 100 - delta + trY;
            //console.log("calcolato " + lampInfo.id + " - px="+px+", py="+py);
            return {x: px+'px', y: py+'px'};
        },
        handleResize(evt) {
            this.$forceUpdate();
        },
        apriModal(index) {
            console.log("apro modal " + index);

            if (this.$store.getters.isProExpired) return;

            this.currentAmbiente = this.ambienti[index];
            
            let self = this;
            this.imgLoaded = false;
            window.setTimeout(function() {
                self.$bvModal.show('modal-ambiente');
                //self.$forceUpdate();
            }, 100);
        }
    }
}
</script>

<style lang="scss">
.modal-fullscreen .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 100000;
}

.nopad {
       padding: 0;
    }
    .imgDiv {
        position: relative;
    }

    .dotImg {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 13px;
        height: 13px;
        
    }

    @keyframes highlightedDotAnim {
        0% {background-color: rgba(255,255,255,0);}
        50% {background-color: rgba(255,255,0,0.8);}
        100% {background-color: rgba(255,255,255,0);}
    }

    .dotImgHighlight {
        background-color: #ffff00;
        width: 61px;
        height: 61px;
        padding: 24px;
        border-radius: 32px;
        animation-name: highlightedDotAnim;
        animation-duration: 1s;
        animation-iteration-count: infinite;
    }
    
    .dotImgBig {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 50px;
        height: 50px;
        padding: 16px;
        background-color: #ffffff11;
        border-radius: 32px;
        z-index: 10000;
    }

    .dotSel {
        background-color: #00990044;
    }

    .modal-xl {
        max-width: 95%;
    }
    .uploadButton {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .infoTip {
        position: absolute;
        right: 5px;
        bottom: 5px;
    }

    .closeButton {
        position: absolute;
        right: 0;
        top: 0;
    }

    #dropzoneContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #eeeeee;
        top: 0;
        margin-top: auto;
        margin-bottom: auto;
        padding: 16px;
        z-index: 11000;
    }
    #dropzone {
        height: 100%;
    }
    .draggableRow {
        cursor: pointer;
    }
    .lampUsed {
        background-color: #ffff;
    }

    .highlightedRow {
        background-color: #b3d3ec;
    }
   
    .highlightedAdded {
        background-color: #ffff;
    }
    .green {
        color: #009900;
    }
    .error {
        color: #cc0000;
    }

    #modal-ambiente .modal-content {
        min-height: 600px;
    }

</style>